import React, { useEffect, useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';
import {
  Box,
  Button,
  Flex,
  Heading,
  Link,
  Spacer,
  Text,
  useColorMode,
  Switch,
  IconButton,
} from '@chakra-ui/react';
import { GiHamburgerMenu } from 'react-icons/gi';
import { IoMdClose } from 'react-icons/io';
import { WiDaySunny, WiMoonWaningCrescent2 } from 'react-icons/wi';
import resume from '../vatars/Rohit-Prajapat-Resume.pdf';

function Navbar() {
  const { colorMode, toggleColorMode } = useColorMode();
  const isDark = colorMode === 'dark';
  const [display, setDisplay] = useState('none');
  const Ref = useRef(null);

  const closeMenu = () => {
    setDisplay('none')
  };

  const toggleMenu = () => {
    setDisplay((prevDisplay) => (prevDisplay === 'none' ? 'flex' : 'none'));
  };

  const AnimatedButton = ({ children, to }) => (
    <NavLink to={to} onClick={closeMenu}>
      <Button
        as="a"
        variant="ghost"
        aria-label={children}
        my={5}
        w="100%"
        _hover={{ transform: 'scale(1.1)', transition: 'transform 0.3s ease-in-out' }}
        _active={{ transform: 'scale(0.9)' }}
      >
        {children}
      </Button>
    </NavLink>
  );

  return (
    <>
      <Flex
        width="100vw"
        bg={isDark ? '#1a202c' : 'white'}
        justifyContent="space-between"
        position="sticky"
        top="0"
        alignItems="center"
        p={4}
        zIndex={1000}
      >
        <Box>
          <Flex marginLeft={['50px', '0px', '10px', '50px']}>
            <Text
              textShadow={isDark ? '0 0 10px white' : '0 0 10px black'}
              color={isDark ? 'white' : '#6F4C5B'}
              as="em"
              fontSize={['22px', '28px', '32', '52px']}
            >
              Rohit Prajapat
            </Text>
          </Flex>
        </Box>
        <Flex>
          <Flex gap="30px" marginRight={['30px', '30px', '10px', '30px']} display={['none', 'none', 'flex', 'flex']}>
            <AnimatedButton to="/">Home</AnimatedButton>
            <AnimatedButton to="/about">About</AnimatedButton>
            <AnimatedButton to="/projects">Projects</AnimatedButton>
            <AnimatedButton to="/skills">Skills</AnimatedButton>
            <AnimatedButton to="/contactus">Contact</AnimatedButton>
            <a href={resume} download>
              <Button
                as="a"
                variant="ghost"
                aria-label="Download Resume"
                my={5}
                w="100%"
                _hover={{ transform: 'scale(1.1)', transition: 'transform 0.3s ease-in-out' }}
                _active={{ transform: 'scale(0.9)' }}
              >
                Resume
              </Button>
            </a>
          </Flex>

          <IconButton
            aria-label="Open Menu"
            size="lg"
            mr={2}
            icon={<GiHamburgerMenu />}
            display={['flex', 'flex', 'none', 'none']}
            onClick={toggleMenu}
          />
          <Switch margin="auto" marginRight={['30px', '0px', '10px', '30px']} color="green" isChecked={isDark} onChange={toggleColorMode} />
        </Flex>
      </Flex>

      <Flex
       
        variant="solid"
        backdropFilter="blur(20px)"
        display={display}
        width="100vw"
        zIndex={20}
        height="100vh"
        pos="fixed"
        top="0"
        left="0"
      >
        <Flex justify="flex-end" >
            
          <IconButton mt={2} mr={2} aria-label="Close Menu" size="lg" icon={<IoMdClose />} onClick={closeMenu} />
        </Flex>
        <Flex flexDir="column" margin="auto">
          <AnimatedButton to="/">Home</AnimatedButton>
          <AnimatedButton to="/about">About</AnimatedButton>
          <AnimatedButton to="/projects">Projects</AnimatedButton>
          <AnimatedButton to="/skills">Skills</AnimatedButton>
          <AnimatedButton to="/contactus">Contact</AnimatedButton>
          <a href={resume} download>
            <Button
              as="a"
              variant="ghost"
              aria-label="Download Resume"
              my={5}
              w="100%"
              _hover={{ transform: 'scale(1.1)', transition: 'transform 0.3s ease-in-out' }}
              _active={{ transform: 'scale(0.9)' }}
            >
              Resume
            </Button>
          </a>
        </Flex>
      </Flex>
    </>
  );
}

export default Navbar;
